import { isOverseas } from './env';

const CDN_URL_ZH = 'https://cdn.hailuoai.com/hailuo-web/';
const CDN_URL_EN = 'https://cdn.hailuo.ai/hailuo-ai-web/hailuo-en/';

export const assetUrl = `${isOverseas ? CDN_URL_EN : CDN_URL_ZH}image/`;

export const privacyPolicyUrl = '/doc/privacy-policy.html';
export const termsOfServiceUrl = '/doc/terms-of-service.html';

export const MINIMAX_URL = isOverseas ? 'https://www.minimax.io/' : 'https://www.minimaxi.com/';
